<template>
  <Dialog
    v-model="isOpen"
    v-bind="$attrs"
    :content-class="'more-user-order-share-dialog'"
    :show-actions="false"
  >
    <template #content>
      <ShareOrder
        :order-id="orderId"
        :screen-type="SHARE_ORDER_SCREEN_TYPE.list"
        :order-users="props.orderUsers"
        @closeSubmitOrderShareDialog="closeSubmitOrderShareDialog"
      />
    </template>
  </Dialog>
</template>

<script setup lang="ts">
import { computed } from "vue";
import Dialog from "@/components/dialogs/Dialog.vue";
import ShareOrder from "@/components/orders/ShareOrder.vue";
import { SHARE_ORDER_SCREEN_TYPE } from "@/utils/constants";
import type { PropType } from 'vue';
import { OrderUser } from "@/entities/order-user";

defineOptions({
  name: 'MoreUserOrderShareDialog'
})

const props = defineProps({
  modelValue: Boolean,
  orderId: { type: Number, required: true },
  orderUsers: {
    type: Array as PropType<OrderUser[]>,
    required: false,
    default: () => [],
  },
});

const emit = defineEmits<{
  "update:modelValue": [value: boolean]
  "closeSubmitOrderShareDialog": [args: string | null]
}>()

const isOpen = computed({
  get: () => props.modelValue,
  set: (val: boolean) => emit("update:modelValue", val),
});

function closeSubmitOrderShareDialog(args: string | null) {
  emit("closeSubmitOrderShareDialog", args);
}
</script>

<style lang="scss">
.more-user-order-share-dialog {
  .v-card > .v-card__text {
    padding-bottom: 1rem;
  }

  .v-card__actions {
    display: none;
  }

  .sub-title {
    font-weight: bold;
  }

  .share-btn {
    display: block;
    white-space: break-spaces;
  }
}
</style>
